const UPDATES = [
  { id: 1, date: '2026-07-30', title: '《国产经典电影合集》新增12部91年影片', tag: '片源更新' },
  { id: 2, date: '2026-07-29', title: '国产电视剧《岁月如歌》全40集上线', tag: '新剧上线' },
  { id: 3, date: '2026-07-28', title: '91国产视频专区画质全面升级至1080P', tag: '平台升级' },
  { id: 4, date: '2026-07-27', title: '热门国产综艺《欢乐大本营》最新季更新', tag: '综艺更新' },
  { id: 5, date: '2026-07-26', title: '移动端播放器优化，加载速度提升40%', tag: '体验优化' },
  { id: 6, date: '2026-07-25', title: '纪录片专区新增《中国故事》系列10部', tag: '内容上新' },
  { id: 7, date: '2026-07-24', title: '网站夜间模式上线，护眼观影更舒适', tag: '功能更新' },
  { id: 8, date: '2026-07-23', title: '《91年国产影片回顾特辑》专题页面上线', tag: '专题发布' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-500">91国产视频平台近期更新与公告</p>
        </div>
        <div className="max-w-3xl mx-auto">
          {UPDATES.map((item, idx) => (
            <div key={item.id} className="flex gap-4 relative">
              <div className="flex flex-col items-center">
                <div className="w-3 h-3 rounded-full bg-primary-500 flex-shrink-0 mt-1.5 z-10" />
                {idx < UPDATES.length - 1 && (
                  <div className="w-0.5 flex-1 bg-background-200 mt-1" />
                )}
              </div>
              <div className={`flex-1 pb-6 ${idx === UPDATES.length - 1 ? 'pb-0' : ''}`}>
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm md:text-base text-foreground-700 font-medium">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}